
  export default {
    props: {
      vehicleImage: {
        type: String,
        default: '250x165.png'
      },
      vehicleName: {
        type: String,
        default: 'Bike Name'
      },
      price: {
        type: Number,
        default: 0
      },
      strikePrice: {
        type: Number,
        default: 0
      },
      renters: {
        type: Number,
        default: 0
      },
      offerNumber: {
        type: Number,
        default: 0
      },
      vloader: {
        type: Boolean,
        default: false
      },
      getDealsLoading: {
        type: Boolean,
        default: false
      },
      locationId: {
        type: String,
        default: 'Vehicle Location'
      },
      vehicleData: {
        default: {}
      },
      selectedId: {
        default: null
      }
    },
    data() {
      return {
        quantity: 1,
        btnId: null
      }
    },
    methods: {
      setFallbackImageUrl(event) {
        event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
      },
      getDeals(vehicleData) {
        let val = {
          quantity: this.quantity,
          id: vehicleData ? vehicleData._id : null
        }
        this.$emit("getDealsClicked", val);
      },
      roundOffValue(num){
      return Math.round(num * 100) / 100
    },
    }
  }
